<template>
    <AtualizarCliente />
</template>

<script>
import AtualizarCliente from '@/components/Cliente/AtualizarCliente'
export default {
  components: {AtualizarCliente},
  data(){
    return{}
  }
}
</script>

<style>

</style>